<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">

        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-10">
                                    <h4 class="font-weight-bold text-primary">All Products</h4>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-6 p-4">
                                <div class="row">
                                    <div class="col-sm-6 mb-3" v-for="detail in details.files"
                                         :key="detail.id">
                                        <div class="card">
                                            <a data-fancybox="gallery" :href="detail.filePath">
                                                <img class="card-img-top" v-lazy="detail.filePath" :alt="uniqueId"
                                                     style="width: 100%;">
                                            </a>
                                            <div class="card-body">
                                                <p class="text-center">
                                                    <button type="button" class="btn btn-danger btn-sm"
                                                            @click="deleteImage(detail.id)">
                                                        <i class="fa fa-trash"></i>
                                                    </button>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 pt-4">
                                <div>
                                    <h2>{{details.title}}</h2>
                                </div>
                                <div>
                                    <h3>Ksh {{Math.round(details.price) | formatNumber}}</h3>
                                </div>
                                <div>
                                    <div class="form-group p-3">
                                        <label>Change status</label>
                                        <select v-model="details.status" @change="changeStatus($event)"
                                                class="form-control">
                                            <option value="0">Out of Stock</option>
                                            <option value="1">In Stock</option>
                                        </select>
                                    </div>
                                </div>
                                <div>
                                    <hr>
                                    <vue-tabs>
                                        <v-tab title="Product Details">
                                            <h5 class="p-2">Product Description</h5>
                                            <div>
                                                <p v-html="details.description"></p>
                                            </div>
                                        </v-tab>

                                        <v-tab title="Edit">
                                            <div class="row mt-3">
                                                <div class="col-sm-6">
                                                    <div class="form-group">
                                                        <label><b>Select Category</b></label>
                                                        <v-select v-model="form2.category" label="name"
                                                                  :options="categories"
                                                                  :reduce="category => category.id"
                                                                  placeholder="Select Category"
                                                                  @input="getSubCategories"></v-select>
                                                        <small style="color: red" v-if="error && errors.category">{{
                                                            errors.category[0]
                                                            }}</small>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6">
                                                    <div class="form-group">
                                                        <label><b>Select Sub-Category</b></label>
                                                        <v-select v-model="form2.subcategory" label="name"
                                                                  :options="subcategories"
                                                                  :reduce="sub => sub.id"
                                                                  placeholder="Select Sub-Category"
                                                                  @input="getBrands"></v-select>
                                                        <small style="color: red" v-if="error && errors.subcategory">{{
                                                            errors.subcategory[0]
                                                            }}</small>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6">
                                                    <div class="form-group">
                                                        <label><b>Select Brand</b></label>
                                                        <v-select v-model="form2.brand" label="name" :options="brands"
                                                                  :reduce="brand => brand.id"
                                                                  placeholder="Select Brand"></v-select>
                                                        <small style="color: red" v-if="error && errors.brand">{{
                                                            errors.brand[0]
                                                            }}</small>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12">
                                                    <div class="form-group">
                                                        <label><b>Title</b></label>
                                                        <input v-model="form2.title" type="text" name="title"
                                                               placeholder="Title"
                                                               class="form-control">
                                                        <small style="color: red" v-if="error && errors.title">{{
                                                            errors.title[0]
                                                            }}</small>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6">
                                                    <div class="form-group">
                                                        <label><b>Price</b></label>
                                                        <input v-model="form2.price" type="number" name="price"
                                                               placeholder="price" class="form-control">
                                                        <small style="color: red" v-if="error && errors.price">{{
                                                            errors.price[0]
                                                            }}</small>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6">
                                                    <div class="form-group">
                                                        <label><b>Quantity/Size (Optional)</b></label>
                                                        <input v-model="form2.quantity" type="text" name="quantity"
                                                               placeholder="Quantity/Size"
                                                               class="form-control">
                                                        <small style="color: red" v-if="error && errors.quantity">{{
                                                            errors.quantity[0]
                                                            }}</small>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12">
                                                    <div class="form-group">
                                                        <label>Description</label>
                                                        <vue-editor v-model="form2.description"
                                                                    :editorToolbar="myToolbar"></vue-editor>
                                                        <small style="color: red" v-if="error && errors.description">{{
                                                            errors.description[0]
                                                            }}</small>
                                                    </div>
                                                </div>
                                                <hr>
                                                <div class="col-sm-12">
                                                    <div class="form-group">
                                                        <label>Upload More Images</label>
                                                        <VueFileAgent
                                                                :accept="'image/*'"
                                                                :multiple="true"
                                                                :deletable="true"
                                                                :maxSize="'10MB'"
                                                                :maxFiles="14"
                                                                v-model="attachments"
                                                                @select="filesSelected($event)"
                                                                @delete="fileDeleted($event)"></VueFileAgent>
                                                        <small style="color: red" v-if="error && errors.files">{{
                                                            errors.files[0]
                                                            }}</small>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12">
                                                    <div class="form-group">
                                                        <button type="submit" class="btn btn-primary"
                                                                @click="updateProduct">Update Product
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </v-tab>

                                        <v-tab title="Third tab">
                                            Third tab content
                                        </v-tab>
                                    </vue-tabs>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>

</template>
<script>
    import {VueEditor} from "vue2-editor";

    export default {
        name: 'tables',
        components: {
            VueEditor,

        },
        data() {
            return {
                errors: {},
                error: false,
                isLoading: false,
                fullPage: true,
                fd: new FormData(),
                filesDataForUpload: [],
                attachments: [],
                myToolbar: [["bold", "italic"], [{list: "ordered"}, {list: "bullet"}]],
                brands: [],
                categories: [],
                subcategories: [],
                details: {},
                uniqueId: this.$route.params.uniqueId,
                form: {
                    status: ''
                },
                form2: {
                    brand: '',
                    category: '',
                    subcategory: '',
                    title: '',
                    price: '',
                    description: '',
                    quantity: ''
                }
            }
        },
        computed: {
            /* subCat() {
                 if (this.form2.category) {
                     return this.getSubCategories();
                 }
             }*/
        },
        methods: {
            updateProduct() {

                this.isLoading = true;
                for (let i = 0; i < this.filesDataForUpload.length; i++) {
                    this.fd.append('files[]', this.filesDataForUpload[i].file);
                }
                this.fd.append('brand', this.form2.brand);
                this.fd.append('category', this.form2.category);
                this.fd.append('subcategory', this.form2.subcategory);
                this.fd.append('title', this.form2.title);
                1
                this.fd.append('price', this.form2.price);
                this.fd.append('description', this.form2.description);
                this.fd.append('quantity', this.form2.quantity);

                const config = {headers: {'Content-Type': 'multipart/form-data'}};
                this.axios.post('/admin/shopLocal/update-product/' + this.uniqueId, this.fd, config).then(() => {
                    this.isLoading = false;
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Success!!',
                        text: 'Product updated Successfully',
                    })
                    this.getDetails();
                })
                    .catch(error => {
                        this.isLoading = false;
                        this.error = true;
                        this.errors = error.response.data.errors;
                    });
            },
            fileDeleted: function (fileData) {
                var i = this.filesDataForUpload.indexOf(fileData);
                if (i !== -1) {
                    this.filesDataForUpload.splice(i, 1);
                } else {
                    this.deleteUploadedFile(fileData);
                }
            },
            filesSelected: function (filesDataNewlySelected) {
                var validFilesData = filesDataNewlySelected.filter((fileData) => !fileData.error);
                this.filesDataForUpload = this.filesDataForUpload.concat(validFilesData);
            },
            getSubCategories() {
                this.form.subcategory = '';
                this.form.brand = '';
                this.axios.get("/admin/shopLocal/sub-category/" + this.form2.category).then(({data}) => ([
                    this.subcategories = data,
                    this.getBrands()
                ]));
            },
            getCategories() {
                this.axios.get("/admin/shopLocal/category").then(({data}) => ([
                    this.categories = data,
                    this.getSubCategories()
                ]));
            },
            getBrands() {
                this.form.brand = '';
                this.axios.get("/admin/shopLocal/my-brands/" + this.form2.subcategory).then(({data}) => ([this.brands = data]));
            },
            deleteImage(id) {
                this.$swal.fire({
                    title: 'Delete this Image?',
                    text: 'You wont be able to revert this!',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                }).then((result) => {
                    // send the request to the controller
                    if (result.value) {
                        this.axios.delete("/admin/shopLocal/delete-image/" + id).then(() => {
                            this.$swal.fire(
                                'Success!',
                                'Status updated successfully',
                                'success'
                            )
                            this.getDetails();
                        });
                    }
                }).catch(() => {
                    this.$swal("Failed!", "There was something wrong.", "warning");
                })
            },
            changeStatus(event) {
                this.form.status = event.target.value;
                this.$swal.fire({
                    title: this.form.status == 0 ? 'Mark as Out of Stock?' : 'Mark as In Stock?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, update status!',
                }).then((result) => {
                    // send the request to the controller
                    if (result.value) {
                        this.axios.patch("/admin/shopLocal/update-status/" + this.uniqueId, this.form).then(() => {
                            this.$swal.fire(
                                'Success!',
                                'Updated successfully',
                                'success'
                            )
                            this.getDetails();
                        });
                    }
                }).catch(() => {
                    this.$swal("Failed!", "There was something wrong.", "warning");
                })
            },
            getDetails() {
                this.axios.get("/admin/shopLocal/details/" + this.uniqueId).then(({data}) => ([
                    this.details = data,
                    this.form2.category = this.details.category_id,
                    this.form2.subcategory = this.details.sub_category_id,
                    this.form2.brand = this.details.brand_id,
                    this.form2.title = this.details.title,
                    this.form2.price = this.details.price,
                    this.form2.description = this.details.description,
                ]));
            }
        },
        created() {
            this.getDetails();
            this.getCategories();
        }
    };
</script>
<style></style>
